import type { EDSLayoutSlots } from '@/types/eds/EDSLayoutSlots';
import type { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';

type EdsDebugServiceLogResponseData = {
  rawResponse?: any;
  section?: string;
  normalizedResponse?: NormalizedV2Response | NormalizedV2Response[];
  dataBySlot?: EDSLayoutSlots<any>;
  includedEntities?: string[];
  includedEntitiesRecord?: Record<string, NormalizedV2Response | NormalizedV2Response[]>;
  ignoreEdsDebugMode?: boolean;
};

class EdsDebugService {
  public static logResponse(
    entityCode: EdsEntityCodes,
    {
      section,
      rawResponse,
      normalizedResponse,
      dataBySlot,
      includedEntities,
      includedEntitiesRecord,
      ignoreEdsDebugMode,
    }: EdsDebugServiceLogResponseData,
  ) {
    /* eslint-disable no-console */
    if (JSON.parse(import.meta.env.VITE_EDS_DEBUG) || ignoreEdsDebugMode) {
      console.groupCollapsed(
        '%cEdsDebug: FE Normalization',
        'color: #6e7681; font-weight: bold; font-size: 12px;',
        [entityCode, section].filter(Boolean).join('_'),
      );

      rawResponse &&
        console.log(
          '%cEdsDebug: Raw Response ➜',
          'color: #e3b341; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
          rawResponse,
        );

      normalizedResponse &&
        console.log(
          '%cEdsDebug: Normalized Response ➜',
          'color: #e3b341; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
          normalizedResponse,
        );

      dataBySlot &&
        console.log(
          '%cEdsDebug: Slots and Fields ➜',
          'color: #e3b341; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
          dataBySlot,
        );

      includedEntities &&
        console.log(
          '%cEdsDebug: Included Entities ➜',
          'color: #e3b341; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
          includedEntities,
        );

      includedEntitiesRecord &&
        console.log(
          '%cEdsDebug: Included Entities Record ➜',
          'color: #e3b341; font-weight: bold; padding: 2px 4px; border-radius: 3px;',
          includedEntitiesRecord,
        );
      console.groupEnd();
    }
    /* eslint-enable no-console */
  }
}

export default EdsDebugService;
